import React from "react";
import tw from "tailwind-styled-components";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

function KPIs({ data, setIsShowAnalytics, canViewFinance }) {
  const navigate = useNavigate();
  // const metrics = [
  //   { label: "Today's Lead", value: data?.todayLeads, link: "/leads" },
  //   { label: "Active Leads", value: data?.activeLeads, link: "/leads" },
  //   { label: "Today's Followup", value: data?.todayFollowup, link: "/leads/followups" },
  //   { label: "Site Visit", value: data?.todayVisits, link: "/leads/visits", color: "text-green-600" },
  //   { label: "Bookings", value: data?.totalBookings, link: "/bookings", color: "text-amber-600" },
  //   { label: "Vacant Beds", value: data?.vacantBeds, link: "/vacancy-by-property", color: "text-rose-600" },
  //   // { label: "Bookings", value: data?.todayBookingTenants, link: "/tenants/active", color: "text-sky-600" },
  // ];
  const metrics = [
    {
      label: "Total Meals",
      value: data?.totalMealOptIn,
      link: "/meal-summary",
      //color: "text-sky-600",
      //bg: "bg-sky-50",
    },
    {
      label: "Breakfast",
      value: `${data?.breakfastServed ?? 0}/${data?.breakfastOptIn ?? 0}`,
      link: "/meal-summary",
      color: "text-amber-600",
      bg: "bg-sky-50",
    },
    // {
    //   label: "Active Leads",
    //   value: data?.activeLeads,
    //   link: "/leads",
    //   color: "text-violet-600",
    //   bg: "bg-violet-50",
    // },
    {
      label: "Lunch",
      value: `${data?.lunchServed ?? 0}/${data?.lunchOptIn ?? 0}`,
      link: "/meal-summary",
      color: "text-orange-600",
      bg: "bg-indigo-50",
    },
    {
      label: "Snacks",
      value: `${data?.snacksServed ?? 0}/${data?.snacksOptIn ?? 0}`,
      link: "/meal-summary",
      color: "text-purple-600",
      bg: "bg-emerald-50",
    },
    {
      label: "Dinner",
      value: `${data?.dinnerServed ?? 0}/${data?.dinnerOptIn ?? 0}`,
      link: "/meal-summary",
      color: "text-emerald-600",
      bg: "bg-blue-50",
    },
    {
      label: "Meal Opt Out",
      value: data?.mealOptOut,
      //link: "/bookings",
      //color: "text-purple-600",
      bg: "bg-amber-50",
    },
    {
      label: "Open Complaints",
      value: data?.openComplaints,
      link: "/complaints",
      color: "text-rose-600",
      bg: "bg-rose-50",
    },
  ];

  return (
    <Container>
      <HeaderRow>
        <MetricsRow>
          <MetricsScroll>
            {metrics.map((item, index) => (
              <Metric
                key={index}
                onClick={() => {
                    if (item?.link)
                        navigate(item.link);
                    }
                }
              >
                <MetricLabel>{item.label}</MetricLabel>

                <MetricValue className={item.color || "text-gray-900"}>
                  {item.value ?? 0}
                  <Arrow />
                </MetricValue>
              </Metric>
            ))}
          </MetricsScroll>
        </MetricsRow>
        {canViewFinance &&
          <ArrowStatic onClick={() => {
            setIsShowAnalytics(true);
          }}>
            →
          </ArrowStatic>
        }
      </HeaderRow>
      {/* <ContextNote>
        Date filter does not affect these values.
      </ContextNote> */}
    </Container>
  );
}

const Container = tw.div`
  mt-2 md:mt-6
  bg-white rounded-lg shadow-sm
  px-4 py-4 md:px-8
`;

const HeaderRow = tw.div`
  flex items-start justify-between
  w-full
`;

const MetricsScroll = tw.div`
  flex gap-2
  overflow-x-auto
  scrollbar-hide
  justify-end
  pb-1
  grid md:grid-cols-7 xl:grid-cols-8 grid-cols-4
`;

const Metric = tw.div`
  min-w-[110px]
  flex-shrink-0
  cursor-pointer
  group
`;

const MetricLabel = tw.div`
  text-[9px] md:text-[11px] uppercase tracking-wide text-gray-500
  whitespace-nowrap
`;

const MetricValue = tw.div`
  flex items-center gap-1
  text-lg font-semibold
  transition-colors
`;

const Arrow = tw(IoIosArrowForward)`
  text-gray-400 text-xs
  opacity-0 group-hover:opacity-100
  transition-opacity
`;

const MetricsRow = tw.div`
  flex-1 
   min-w-0
`;

const ContextNote = tw.div`
  mt-0
  -mb-2
  pr-0
  text-[10px]
  text-gray-300
  text-right
  hidden lg:block
  leading-tight
`;

const ArrowStatic = tw.span`
  text-gray-400 text-lg
  cursor-pointer
  hover:text-gray-600
  transition
  ml-4
  flex-shrink-0
  self-start
`;

export default KPIs;